const getSummaryLabel = (label: string) => {
  return `summary.${label.replace(/^(field|summary)\./, '')}`
}

export default getSummaryLabel
